import { FC, useEffect } from 'react';
import { IcBan28 } from '$assets';
import { useTranslator } from '$hooks';
import './PaymentFailed.sass';
import { Placeholder } from '$uikit';
import { statReachGoal } from '$utils';
import { useSelector } from 'react-redux';
import { paySelector } from '$store/pay/index';

export const PaymentFailed: FC = ({ children }) => {
  const t = useTranslator();
  const { errorCode } = useSelector(paySelector);

  useEffect(() => {
    statReachGoal('payment_failed');
  }, []);

  return (
    <Placeholder centered>
      <div className="PaymentFailed">
        <IcBan28 />
        <h1>{t('payment_failed_title')}</h1>
        {errorCode ? (
          <div className="PaymentFailed__description">
            {t(`payment_failed_${errorCode}`)} ({errorCode})
          </div>
        ) : (
          <div className="PaymentFailed__description">
            {t('payment_failed_list_title')}
            <ol className="PaymentFailed__list">
              <li>{t('payment_failed_list_item_1')}</li>
              <li>{t('payment_failed_list_item_2')}</li>
              <li>{t('payment_failed_list_item_3')}</li>
            </ol>
          </div>
        )}
        {children}
      </div>
    </Placeholder>
  );
};
